export const availableSizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
